import { escapeHtml } from "./sanitize";

/** Tiny markdown → React: #/##/### headings, **bold**, *em*, `code`, "- " bullets, --- rules. */
export function renderMd(md, { size = "sm" } = {}) {
  if (!md) return null;
  const text = size === "base" ? "text-[15px]" : "text-sm";
  const inline = (t) =>
    escapeHtml(t).replace(/\*\*([^*]+)\*\*/g, '<strong class="font-semibold text-[#0a0a0a]">$1</strong>')
      .replace(/\*([^*]+)\*/g, "<em>$1</em>")
      .replace(/`([^`]+)`/g, '<code class="font-mono-bm text-[13px]">$1</code>');
  const lines = md.split(/\r?\n/);
  const out = [];
  let ul = [];
  const flush = () => {
    if (ul.length) {
      out.push(
        <ul key={`ul-${out.length}`} className={`list-disc pl-5 space-y-1 my-2 ${text} text-neutral-800`}>
          {ul.map((t, i) => <li key={i} dangerouslySetInnerHTML={{ __html: inline(t) }} />)}
        </ul>
      );
      ul = [];
    }
  };
  for (const raw of lines) {
    const line = raw.trimEnd();
    if (/^#{1,3}\s+/.test(line)) {
      flush();
      const level = line.match(/^(#{1,3})/)[1].length;
      out.push(
        <h4 key={`h-${out.length}`} className={`bm-headline mt-4 mb-1 ${level === 1 ? "text-xl" : "text-lg"}`}>
          {line.replace(/^#{1,3}\s+/, "")}
        </h4>
      );
    } else if (/^\s*(-{3,}|\*{3,})\s*$/.test(line)) {
      flush();
      out.push(<hr key={`hr-${out.length}`} className="my-3 border-[#0a0a0a]/20" />);
    } else if (/^\s*[-*]\s+/.test(line)) {
      ul.push(line.replace(/^\s*[-*]\s+/, ""));
    } else if (line.trim() === "") {
      flush();
    } else {
      flush();
      out.push(<p key={`p-${out.length}`} className={`${text} text-neutral-800 my-2 leading-relaxed`} dangerouslySetInnerHTML={{ __html: inline(line) }} />);
    }
  }
  flush();
  return out;
}
